import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { cardStyle, accent, textPrimary, bgMuted, primaryBtn } from './styles'
import EventProBrand from './EventProBrand'
import EventCard from './EventCard'
import { formatElapsed, generateTimedShareText, getHomeUrl } from './gameLogic'

export default function RevealScreen({ run, playerName }) {
  const [copied, setCopied] = useState(false)
  const [copyError, setCopyError] = useState('')
  const shareText = generateTimedShareText(run)
  const copy = async () => {
    try { await navigator.clipboard.writeText(shareText); setCopied(true); setCopyError('') }
    catch (_) { setCopyError('Select and copy your result below.') }
  }
  return <main style={{ minHeight: '100vh', background: bgMuted, padding: '24px 16px 48px' }}>
    <div style={{ maxWidth: 560, margin: '0 auto' }}>
      <div style={{ marginBottom: 24 }}><EventProBrand /></div>
      <section style={{ ...cardStyle, textAlign: 'center', marginBottom: 20 }}>
        <div style={{ color: '#666', fontSize: '.85rem' }}>{playerName} · {run.date}</div>
        <h1 style={{ color: textPrimary }}>Your timeline is complete</h1>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, margin: '24px 0' }}>
          <div style={{ padding: 16, borderRadius: 12, background: '#fff7ed' }}><div style={{ color: '#666', fontSize: '.8rem' }}>Correct placements</div><strong style={{ fontSize: '2.5rem', color: accent }}>{run.accuracy}/4</strong></div>
          <div style={{ padding: 16, borderRadius: 12, background: '#f5f5f5' }}><div style={{ color: '#666', fontSize: '.8rem' }}>Final time</div><strong style={{ fontSize: '2.2rem', fontVariantNumeric: 'tabular-nums' }}>{formatElapsed(run.elapsed_ms)}</strong></div>
        </div>
        <p style={{ color: '#666', lineHeight: 1.6 }}>Ranked by correct placements, then fastest time. Your result has been saved.</p>
        <Link to="/leaderboard" style={{ ...primaryBtn, display: 'block', textDecoration: 'none', boxSizing: 'border-box' }}>View leaderboard</Link>
      </section>
      <section style={{ ...cardStyle, marginBottom: 20 }}>
        <h2 style={{ fontSize: '1.1rem', marginTop: 0 }}>The full timeline</h2>
        <p style={{ color: '#777', fontSize: '.85rem' }}>Most recent at the top. Each mark shows whether your placement was correct.</p>
        {[run.anchor, ...run.placed_events].sort((a,b) => b.year-a.year).map(event => <EventCard key={event.id} event={event} isAnchor={event.id === run.anchor.id} showYear wasStrike={event.wasStrike} />)}
      </section>
      <section style={cardStyle}>
        <h2 style={{ fontSize: '1.1rem', marginTop: 0 }}>Share your result</h2>
        <pre style={{ whiteSpace: 'pre-wrap', lineHeight: 1.7, fontSize: '.9rem' }}>{shareText}</pre>
        <button onClick={copy} style={primaryBtn}>{copied ? 'Copied!' : 'Copy result'}</button>
        {copyError && <p role="status">{copyError}</p>}
      </section>
      <p style={{ textAlign: 'center', marginTop: 24 }}><a href={getHomeUrl()} style={{ color: accent }}>Back to Games Hub</a></p>
    </div>
  </main>
}
